module.exports = "//public.getcloudapp.com/packs/media/images/download-windows-ae5ec90553bc2740b8cfd7a6ea099a48.svg";